import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 保存空运区域
export function saveAirRegion(data, params) {
  return request({
    url: URL.mdm.basicData.saveAirRegion,
    method: 'post',
    data,
    params
  })
}

// 删除空运区域
export function deleteAirRegion(params) {
  return request({
    url: URL.mdm.basicData.deleteAirRegion,
    method: 'delete',
    params
  })
}
